// extracted by mini-css-extract-plugin
export default {"pqrsTable":"PQRsTable_pqrsTable__HHztQ","header":"PQRsTable_header__t3svO","topBar":"PQRsTable_topBar__hus5C"};